import React from 'react';

import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import {PaperProps, withStyles} from '@material-ui/core';
import {Guideline} from '@epic-ui/icons';
import {getDirectionStyles} from '../../utils/ThemeUtils';
import {Tooltip} from '../../components';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

export interface TimeRangeButtonProps extends PaperProps {
    title: string;
    tooltipTitle: string;
}

const TimeRangeButton = withStyles<string, undefined, TimeRangeButtonProps>(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        borderRadius: 0,
        outline: 'none',

        height: theme.spacing(8),
        padding: theme.spacing(0, 2),
        backgroundColor: theme.palette.action.selected,

        '& > span': {
            fontSize: '14px',
            marginLeft: theme.spacing(3)
        },
        '& > svg': {
            transform: getDirectionStyles(theme.direction)('none', 'rotate(180deg)')
        },
        '& svg:first-of-type': {
            fontSize: '1.2rem'
        },
        '& svg:last-of-type': {
            display: 'block'
        }
    }
}))(({title, tooltipTitle, ...props}: TimeRangeButtonProps) => (
    <Paper aria-label="button" tabIndex={0} {...props}>
        <ChevronLeft />
        <Typography variant="body1" component="span">
            {title}
        </Typography>

        <Box display="flex" alignItems="center" ml={2}>
            <Tooltip
                placement="top"
                title={tooltipTitle}
                onClick={e => {
                    e.stopPropagation();
                }}>
                <div>
                    <Guideline />
                </div>
            </Tooltip>
        </Box>
    </Paper>
));

export default TimeRangeButton;
